import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import api from "service/api";
import { toast } from "react-toastify";
import PaginationComponent from "components/Pagination/Pagination";
import usePagination from "hooks/usepagination";
import ModalMeuSputiContent from "components/Modal/ModalMeuSputiContent";
import ModalConfirm from "../components/Modal/ModalConfirm";
import {
  Card,
  CardHeader,
  CardFooter,
  Table,
  Container,
  Row,
  Form,
  Button,
  CardTitle,
  Col,
  CardBody,
} from "reactstrap";
import ModalOriginalContent from "components/Modal/ModalOriginalContent";
import { CookieTool } from "utils/CookieTool";

const MeuSputiContent = () => {
  const { register, handleSubmit, reset } = useForm();
  const [range, setRange] = useState(0);
  const [info, setInfo] = useState([]);
  const { actualPage } = usePagination();
  const [offset, setOffset] = useState(actualPage || 1);
  const [, setOnLoad] = useState(false);
  const [, setTopicNames] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [search, setSearch] = useState("");
  const [limit, setLimit] = useState(100);
  const [isdisabled, setIsdisabled] = useState(false);
  const [clients, setClients] = useState([]);
  const [update, setUpdate] = useState(false);
  const permissions = CookieTool.getLarge("permissions");

  const contentStatus = {
    pending: "Pendente",
    READY: "Pronto",
    FAILED: "Falhou",
  };

  const getContents = async () => {
    setOnLoad(true);

    await api
      .get(
        `/contents/meu-sputi?page=${offset}&limit=${Number(limit)}&${search}`,
      )
      .then((response) => response.data)
      .then((response) => {
        setRange(response.totalPages);
        setTotalCount(response.totalCount);
        const contents = response.contents.map((item) => {
          const created = new Date(item.createdAt).toLocaleString("pt-BR", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
          });
          const updated = new Date(item.updatedAt).toLocaleString("pt-BR", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
          });
          return {
            id: item.id,
            assistant: item.assistant.name,
            client: item.client?.name ?? "N/A",
            topic: item.topicName,
            status: item.status,
            content: item.text,
            reference: item.reference,
            user: item.user.username,
            createdAt: created,
            updatedAt: updated,
          };
        });

        setInfo(contents);

        const topicNames = contents.map((item) => item.topic);
        const topicNamesSet = [...new Set(topicNames)];
        setTopicNames(topicNamesSet);

        api
          .get(`/clients?page=${offset}&limit=${Number(limit)}`)
          .then((response) => response.data)
          .then((response) => {
            const clients = response.clients.map((item) => {
              return item.name;
            });
            setClients(clients);
          })
          .catch((error) => {
            console.error(error);
            toast.error("Erro ao recuperar conteúdos!");
            return;
          });
        setOnLoad(false);
      })
      .catch((error) => {
        if (error.response?.status !== 401) {
          toast.error("Erro ao recuperar conteúdos!");
        }
        return;
      });
  };

  useEffect(() => {
    getContents();
  }, [offset, search, limit, update]);

  const handleDelete = (id) => {
    setIsdisabled(true);
    api
      .delete(`/contents/${id}`)
      .then(() => {
        toast.success("Conteúdo deletado com sucesso!");
        const infoFilter = info.filter((item) => item.id !== id);
        setInfo(infoFilter);
        setIsdisabled(false);
      })
      .catch(() => {
        toast.error("Erro ao deletar conteúdo!");
        setIsdisabled(false);
      });
  };

  const onSubmit = (data) => {
    const { username, clientName } = data;
    let query = "";
    if (username) {
      query += `username=${username}&`;
    }
    if (clientName) {
      query += `clientName=${clientName}&`;
    }
    setSearch(query);
  };

  const clearSearch = () => {
    let query = "";
    setSearch(query);
    reset();
  };

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
  };
  return (
    <>
      <Container className="mt-2" fluid>
        <div className="header bg-gradient-info pb-8 pt-3 pt-md-4 d-flex align-items-center justify-content-center flex-column">
          <div className="container-fluid">
            <Form onSubmit={handleSubmit(onSubmit)} className="d-flex">
              <label className="text-white mr-2 ml-2">Cliente: </label>
              <select
                name="assistant"
                id="assistants"
                className="Input"
                style={{
                  display: "block",
                  width: "100%",
                  height: "calc(1.5em + 1.25rem + 2px)",
                  padding: "0.625rem 0.75rem",
                  fontSize: "0.875rem",
                  fontWeight: "400",
                  lineHeight: "1.5",
                  color: "#8898aa",
                  backgroundColor: "#fff",
                  backgroundClip: "padding-box",
                  border: "1px solid #cad1d7",
                  borderRadius: "0.375rem",
                  boxShadow: "none",
                  transition: "all 0.2s cubic-bezier(0.68, -0.55, 0.265, 1.55)",
                }}
                {...register("clientName")}
              >
                <option value="">Selecione</option>
                {clients.map((client, index) => {
                  return (
                    <option value={client} key={index}>
                      {client}
                    </option>
                  );
                })}
              </select>
              <label className="text-white mr-2 ml-2">Usuário: </label>
              <input
                name="username"
                id="username"
                className="Input"
                style={{
                  display: "block",
                  width: "100%",
                  height: "calc(1.5em + 1.25rem + 2px)",
                  padding: "0.625rem 0.75rem",
                  fontSize: "0.875rem",
                  fontWeight: "400",
                  lineHeight: "1.5",
                  color: "#8898aa",
                  backgroundColor: "#fff",
                  backgroundClip: "padding-box",
                  border: "1px solid #cad1d7",
                  borderRadius: "0.375rem",
                  boxShadow: "none",
                  transition: "all 0.2s cubic-bezier(0.68, -0.55, 0.265, 1.55)",
                }}
                {...register("username")}
              />
              <Button className="Button ml-2" type="submit">
                Buscar
              </Button>
              <Button className="Button ml-2" onClick={clearSearch}>
                Limpar
              </Button>
            </Form>
          </div>
        </div>
      </Container>
      <Container className="mt--7" fluid>
        <div className="container-fluid mb-1">
          <Row>
            <Col lg="6" xl="3">
              <Card className="card-stats ">
                <CardBody className="pb-1">
                  <Row>
                    <div className="d-flex flex-row align-items-center">
                      <CardTitle
                        tag="h6"
                        className="text-uppercase text-muted mb-0 mr-2"
                      >
                        Conteúdos
                      </CardTitle>
                      <span className="h2 mb-0">{totalCount}</span>
                    </div>
                  </Row>
                </CardBody>
              </Card>
            </Col>
            <Col lg="6" xl="3">
              <Card className="card-stats mb-4 mb-xl-0 ">
                <CardBody className="pb-1 ">
                  <Row>
                    <div className="d-flex flex-row align-items-center">
                      <CardTitle
                        tag="h5"
                        className="text-uppercase text-muted mb-0 mr-2"
                      >
                        Paginas
                      </CardTitle>
                      <span className="h2 font-weight-bold mb-0">{range}</span>
                    </div>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0 d-flex ml-2">
                <select
                  style={{
                    display: "block",
                    width: "80px",
                    height: "35px",
                    fontSize: "0.875rem",
                    lineHeight: "1.5",
                    color: "#8898aa",
                    backgroundColor: "#fff",
                    backgroundClip: "padding-box",
                    border: "1px solid #cad1d7",
                    borderRadius: "0.375rem",
                    boxShadow: "none",
                    transition:
                      "all 0.2s cubic-bezier(0.68, -0.55, 0.265, 1.55)",
                    marginLeft: "10px",
                  }}
                  name="limit"
                  id="limit"
                  className="Input"
                  value={limit}
                  onChange={handleLimitChange}
                >
                  <option value="10">10</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
                {permissions?.includes("create:my_sputi_content") && (
                  <ModalMeuSputiContent update={update} setUpdate={setUpdate} />
                )}
              </CardHeader>
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th>Assistente</th>
                    <th>Cliente</th>
                    <th>Usuário</th>
                    <th>Conteúdo</th>
                    <th>Criado</th>
                    <th>Atualizado</th>
                    <th>Status</th>
                    {permissions?.includes("update:my_sputi_content") && (
                      <th>Editar</th>
                    )}
                    {permissions?.includes("remove:my_sputi_content") && (
                      <th>Excluir</th>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {info.map((item) => (
                    <tr key={item.id}>
                      <td>{item.assistant}</td>
                      <td>{item.client}</td>
                      <td title={item?.user}>{item?.user}</td>
                      <td>
                        <div
                          className="text-justify"
                          title={item.content.replace(/(<([^>]+)>)/gi, "")}
                        >
                          <ModalOriginalContent
                            content={item?.content}
                            originalContent={item?.content}
                          />
                        </div>
                      </td>
                      <td>{item.createdAt}</td>
                      <td>{item.updatedAt}</td>
                      <td>{contentStatus[item.status]}</td>
                      {permissions?.includes("update:my_sputi_content") && (
                        <td>
                          <ModalMeuSputiContent
                            ItemContent={item}
                            update={update}
                            setUpdate={setUpdate}
                          />
                        </td>
                      )}
                      {permissions?.includes("remove:my_sputi_content") && (
                        <td>
                          <ModalConfirm
                            id={item.id}
                            modalText={`Esta ação irá excluir o conteúdo ${item.content
                              .replace(/(<([^>]+)>)/gi, "")
                              .substring(0, 20)}, você tem certeza?`}
                            handler={() => {
                              handleDelete(item.id);
                            }}
                            icon={"fas fa-trash"}
                          />
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </Table>
              <CardFooter className="py-4">
                <nav aria-label="...">
                  <PaginationComponent
                    limit={limit}
                    total={range}
                    offset={offset}
                    setOffset={setOffset}
                  />
                </nav>
              </CardFooter>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default MeuSputiContent;
